<template>
  <div id="header">
    <div class="contentWidth">
      <span class="logo">

      </span>
      <ul @mouseleave='LinkLeave()'>
        <li v-for="(i,index) in title" :class="LinkClickData.index==index?'pointer':'pointer'" @click="LinkHref(i)" @mouseover='LinkHover(index)'>{{i.name}}</li>
        <span :style="'left:'+(LinkHoverData*140+30)+'px'"></span>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header1',
  data () {
    return {
      title:[
        {
          name:'首页',
          key:'index',
          index:0,
        },
        {
          name:'我们的服务',
          key:'index',
          index:1,
        },
        {
          name:'我们的客户',
          key:'index',
          index:2,
        },
        {
          name:'媒体报道',
          key:'index',
          index:3,
        },
        {
          name:'加入我们',
          key:'index',
          index:4,
        },
        {
          name:'联系我们',
          key:'index',
          index:5,
        },
      ],
      LinkClickData:
      {
        name:'首页',
        key:'index',
        index:0,
      },
      LinkHoverData:0,
    }
  },
  methods:{
    LinkHref(data){//鼠标点击
      this.LinkClickData = data
      switch(data.index){
        case 0:
          this.$router.push('/')
          break;
        case 1:
          this.$router.push('/serve')
          break;
        case 2:
          this.$router.push('/client')
          break;
        case 3:
          this.$router.push('/news')
          break;
        case 4:
          this.$router.push('/join')
          break;
        case 5:
          this.$router.push('/relation')
          break;
        default:
          break;
      }
    },
    LinkHover(data){//鼠标移入
      console.log(data)
      this.LinkHoverData = data;
    },
    LinkLeave(){//鼠标移出
      console.log(this.LinkClickData.index)
      this.LinkHoverData = this.LinkClickData.index;
    }
  },
  watch:{
    $route(to,from){
      console.log('',to,from)
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          document.documentElement.scrollTop=document.body.scrollTop=0;
      
    }
  },
  mounted(){
    console.log('正如is',this.$route.name)
    var path = this.$route.name
    if(path=='client'){
      this.LinkClickData = this.title[2]
      this.LinkHover(2)
    }else if(path=='insurance'){
      this.LinkClickData = this.title[0]
      this.LinkHover(0)
    }else if(path=='serve'){
      this.LinkClickData = this.title[1]
      this.LinkHover(1)
    }else if(path=='join'){
      this.LinkClickData = this.title[4]
      this.LinkHover(4)
    }else if(path=='relation'){
      this.LinkClickData = this.title[5]
      this.LinkHover(5)
    }else if(path=='news'){
      this.LinkClickData = this.title[3]
      this.LinkHover(3)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
@import '../assets/css/norm.less';
#header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  .contentWidth::after{
    content: '';
    clear:both;
  }
  .logo{
    display: inline-block;
    height: 100%;
    width: 200px;
    background: url('../assets/img/index/logo.jpg') no-repeat center;
    background-size: 70%;
    float: left;
    margin-right: 100px;
  }
  ul{
    float: left;
    position: relative;
    li{
      float: left;
      width: 120px;
      text-align: center;
      height: 70px;
      margin: 0 10px;
      box-sizing: border-box;
    }
    span{
      position: absolute;
      bottom: 18px;
      display: inline-block;
      width: 80px;
      height: 2px;
      background: #006ac0;
      transition: all 0.4s;
      -moz-transition: all 0.4s;	/* Firefox 4 */
      -webkit-transition: all 0.4s;	/* Safari 和 Chrome */
      -o-transition: all 0.4s;	/* Opera */
      transition-timing-function: cubic-bezier(0.68, 0.14, 0.33, 0.88);
      -moz-transition-timing-function: cubic-bezier(0.68, 0.14, 0.33, 0.88); /* Firefox 4 */
      -webkit-transition-timing-function: cubic-bezier(0.68, 0.14, 0.33, 0.88); /* Safari 和 Chrome */
      -o-transition-timing-function: cubic-bezier(0.68, 0.14, 0.33, 0.88); /* Opera */
      pointer-events: none;
    }
    li:hover~span{
      // border: none;
      // width: 120px;
      // height: 50px;
      // animation: LinkHover 0.3s;
      // -moz-animation: LinkHover 0.3s;	/* Firefox */
      // -webkit-animation: LinkHover 0.3s;	/* Safari 和 Chrome */
      // -o-animation: LinkHover 0.3s;	/* Opera */
    }
    // @keyframes LinkHover
    // {
    //   0% {
    //     width: 120px;
    //   }
    //   70% {
    //     width: 140px;
    //   }
    //   100%{
    //     width: 120px;
    //   }
    // }

    // @-moz-keyframes LinkHover /* Firefox */
    // {
    //   from {background: red;}
    //   to {background: yellow;}
    // }

    // @-webkit-keyframes LinkHover /* Safari 和 Chrome */
    // {
    //   from {background: red;}
    //   to {background: yellow;}
    // }

    // @-o-keyframes LinkHover /* Opera */
    // {
    //   from {background: red;}
    //   to {background: yellow;}
    // }
  }
  height: 70px;
  font-size: 14px;
  line-height: 70px;
  color: #006ac0;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.2);
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue